import { useEffect, useRef } from "react";

/**
 * Subtle radial spotlight that follows the mouse inside its parent section.
 * Place inside a `relative` container; pass children that should be on top via separate stacking.
 */
export const Spotlight = ({
  size = 600,
  color = "rgba(255,255,255,0.07)",
  className = "",
}) => {
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const parent = node.parentElement;
    if (!parent) return;

    const onMove = (e) => {
      const rect = parent.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      node.style.background = `radial-gradient(${size}px circle at ${x}px ${y}px, ${color}, transparent 60%)`;
      node.style.opacity = "1";
    };
    const onLeave = () => {
      node.style.opacity = "0";
    };

    parent.addEventListener("mousemove", onMove);
    parent.addEventListener("mouseleave", onLeave);
    return () => {
      parent.removeEventListener("mousemove", onMove);
      parent.removeEventListener("mouseleave", onLeave);
    };
  }, [size, color]);

  return (
    <div
      ref={ref}
      aria-hidden="true"
      className={`pointer-events-none absolute inset-0 transition-opacity duration-500 opacity-0 ${className}`}
    />
  );
};

export default Spotlight;
